import { Link, List, ListItem } from 'components/chroma';
import React, { FunctionComponent } from 'react';
import { LinkType } from 'scenes/common/types';
import styled from 'styled-components';

const DesktopLinkTrayContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.8em;

  .c-list {
    align-items: baseline;
    justify-content: space-around;
    width: 100%;

    div {
      margin-right: 1em;
    }

    div:last-of-type {
      margin-right: 0;
    }
  }
`;

export const FooterLinks: FunctionComponent<{
  informationLinks: LinkType[];
}> = ({ informationLinks }) => (
  <DesktopLinkTrayContainer>
    <List inline>
      {informationLinks.map((link) => (
        <ListItem keyProp={`${link.text}`} key={`${link.text}`}>
          <Link href={link.url} target="_blank" rel="noopener noreferrer">
            {link.text}
          </Link>
        </ListItem>
      ))}
    </List>
  </DesktopLinkTrayContainer>
);
